import { monoFont } from '@medcom/shared-ui/styles/globalCss.ts';
import { antdTokenFilter } from '@medcom/shared-ui/utils/tokenSearch.ts';
import { Select, Typography } from 'antd';
import React, { type CSSProperties } from 'react';

const { Option } = Select;

export type Parameter = {
  id: string;
  shortName: string;
  longName: string;
};

interface ParameterSelectProps {
  id?: string;
  multiple?: boolean;
  style?: CSSProperties;
  parameters: Parameter[];
  selected?: string | string[] | undefined;
  onChange?: (value: string | string[]) => void;
}

export const ParameterSelect: React.FC<ParameterSelectProps> = React.memo(({ id, multiple, style, parameters, selected, onChange }) => {
  return (
    <Select
      id={id}
      showSearch={{ filterOption: antdTokenFilter }}
      allowClear
      mode={multiple ? 'multiple' : undefined}
      style={style}
      onChange={onChange}
      value={selected}
      placeholder="Suche nach Parameter"
      optionLabelProp="taglabel"
    >
      {[...parameters]
        .sort((a, b) => a.shortName.localeCompare(b.shortName))
        .map(parameter => {
          return (
            <Option
              key={parameter.id}
              value={parameter.id}
              search={`${parameter.shortName} - ${parameter.longName}`}
              taglabel={<span className={monoFont}>{parameter.shortName}</span>}
            >
              <div className={monoFont}>{parameter.shortName}</div>
              <Typography.Text type="secondary">{parameter.longName}</Typography.Text>
            </Option>
          );
        })}
    </Select>
  );
});
